import { parseISO } from 'date-fns';

export default function contractDate(dateString?: string): string {
  if (!dateString) {
    return 'Não informado';
  }

  const parsedDate = parseISO(dateString);

  if (parsedDate === undefined) {
    return 'Inválido. Entre em contato';
  }

  return parsedDate.toLocaleDateString('pt-BR');
}
